<template>
  <main class="mdl-layout__content">
    <div class="page-content">
      <!--
      <h1 class="mdl-typography--headline">Arkiv</h1>
      <h2 class="mdl-typography--title">Kontroll av tekniske defekter</h2>
      -->
      <div class="reportsFilters">
        <div>
          <date-picker placeholder="Fra dato" @change="onFilterChange()" v-model="archive.filter.startDate" valueType="format"></date-picker>
        </div>
        <div>
          <date-picker placeholder="Til dato" @change="onFilterChange()" v-model="archive.filter.endDate" valueType="format"></date-picker>
        </div>
        <div>
          <div style="width:100%" class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
            <input @change="onFilterChange()" v-model="archive.filter.search" class="mdl-textfield__input" type="text" id="search">
            <label class="mdl-textfield__label" for="search">Søk</label>
          </div>
        </div>
        <div>
          <div style="width:100%" class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
            <input @change="onFilterChange()" v-model="archive.filter.searchFirm" class="mdl-textfield__input" type="text" id="searchFirm">
            <label class="mdl-textfield__label" for="searchFirm">Søk etter firma</label>
          </div>
        </div>
        <template>
          <div class="type-of-reports">
            <template v-if="$root.isAdministrator() || $root.isClient()">
              <div class="type-of-reports__by-user-type">
                <div class="mdl-textfield" style="width: auto" v-if="$root.isAdministrator() && !$root.isEuropcarDenmark()">
                  <label class="mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect" :class="[archive.filter.onlyRegularReports ? 'is-checked' : '']" for="only_regular_reports">
                    <input @change="onFilterChange()" type="checkbox" id="only_regular_reports" v-model="archive.filter.onlyRegularReports" class="mdl-checkbox__input" true-value="1"
                           false-value="0">
                    <span class="mdl-checkbox__label">Regular reports</span>
                  </label>
                </div>
                <div class="mdl-textfield" style="width: auto" v-if="$root.isAdministrator() && !$root.isEuropcarDenmark()">
                  <label class="mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect" :class="[archive.filter.onlyEuropcarReports ? 'is-checked' : '']" for="only_europcar_reports">
                    <input @change="onFilterChange()" type="checkbox" id="only_europcar_reports" v-model="archive.filter.onlyEuropcarReports" class="mdl-checkbox__input" true-value="1"
                           false-value="0">
                    <span class="mdl-checkbox__label">
                Europcar reports</span>
                  </label>
                </div>

                <div v-if="$root.isAdministrator() || $root.isEuropcarDenmark()" class="mdl-textfield" style="width: auto">
                  <label class="mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect" :class="[archive.filter.onlyEuropcarReportsDansk ? 'is-checked' : '']" for="only_europcar_reports_dansk">
                    <input @change="onFilterChange()" type="checkbox" id="only_europcar_reports_dansk" v-model="archive.filter.onlyEuropcarReportsDansk" class="mdl-checkbox__input" true-value="1"
                           false-value="0">
                    <span class="mdl-checkbox__label">
                Europcar reports (dansk)</span>
                  </label>
                </div>
              </div>
            </template>
            <div class="type-of-reports__by-language">
              <div class="mdl-textfield" style="width: auto">
                <label class="mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect" :class="[archive.filter.onlyNorskReports ? 'is-checked' : '']" for="only_norsk_reports">
                  <input @change="onFilterChange()" type="checkbox" id="only_norsk_reports" v-model="archive.filter.onlyNorskReports" class="mdl-checkbox__input" true-value="1"
                         false-value="0">
                  <span class="mdl-checkbox__label">Norsk</span>
                </label>
              </div>

              <div class="mdl-textfield" style="width: auto">
                <label class="mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect" :class="[archive.filter.onlyEngelskReports ? 'is-checked' : '']" for="only_engelsk_reports">
                  <input @change="onFilterChange()" type="checkbox" id="only_engelsk_reports" v-model="archive.filter.onlyEngelskReports" class="mdl-checkbox__input" true-value="1"
                         false-value="0">
                  <span class="mdl-checkbox__label">Engelsk</span>
                </label>
              </div>

              <div class="mdl-textfield" style="width: auto">
                <label class="mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect" :class="[archive.filter.onlyDanskReports ? 'is-checked' : '']" for="only_dansk_reports">
                  <input @change="onFilterChange()" type="checkbox" id="only_dansk_reports" v-model="archive.filter.onlyDanskReports" class="mdl-checkbox__input" true-value="1"
                         false-value="0">
                  <span class="mdl-checkbox__label">Dansk</span>
                </label>
              </div>

              <div class="mdl-textfield" style="width: auto">
                <label class="mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect" :class="[archive.filter.onlySvenskReports ? 'is-checked' : '']" for="only_svensk_reports">
                  <input @change="onFilterChange()" type="checkbox" id="only_svensk_reports" v-model="archive.filter.onlySvenskReports" class="mdl-checkbox__input" true-value="1"
                         false-value="0">
                  <span class="mdl-checkbox__label">Svensk</span>
                </label>
              </div>

            </div>

          </div>

        </template>
        <div>
          <button v-if="isFilterActive()" @click="clearFilter" class="reportsFilterBtn"><i class="material-icons">cancel</i></button>
          <a class="reportsFilterBtn" target="_blank" :href="exportUrl" title="Eksport">
            <i class="material-icons">cloud_download</i>
          </a>
        </div>
      </div>
      <table class="mdl-data-table mdl-shadow--2dp">
        <thead>
        <tr>
          <th class="mdl-data-table__cell--non-numeric">Rapport dato</th>
          <th class="mdl-data-table__cell--non-numeric">ID</th>
          
          <th class="mdl-data-table__cell--non-numeric">Reg.Nr</th>
          <th class="mdl-data-table__cell--non-numeric">Kontaktperson</th>
          <th class="mdl-data-table__cell--non-numeric">Firma</th>
          <th class="mdl-data-table__cell--non-numeric">Bil</th>
          <th class="mdl-data-table__cell--non-numeric">Skadekostnad</th>
          <th class="mdl-data-table__cell--non-numeric">Sendt</th>
          <th class="mdl-data-table__cell--non-numeric">Taksert av</th>
          <th class="mdl-data-table__cell--non-numeric">Forsikrings selskap</th>
        </tr>
        </thead>
        <tbody>
        <tr :id="'report-' + report.id" v-for="report in reports" :class="[getSentColor(report.report_status, report.sent_at) + '-chip', isMadeByCurrentUser(report) ? '' : 'marked' ]" @click="openReport(report)">
          <td class="mdl-data-table__cell--non-numeric"><span v-text="formatDate(report.created_at)"></span> <span v-if="$root.isEuropcarCapability() || $root.isAldCapability() || $root.isRentalCheckCapability()" v-html="getReportStatusLabel(report)"></span></td>
          <td class="mdl-data-table__cell--non-numeric" v-text="report.id"></td>
          <td class="mdl-data-table__cell--non-numeric" v-text="report.id_car.toUpperCase()"></td>
          <td class="mdl-data-table__cell--non-numeric" v-text="report.contact_name"></td>

          <td class="mdl-data-table__cell--non-numeric" v-text="report.firma"></td>
          <td class="mdl-data-table__cell--non-numeric"
              v-text="(report.producer ? report.producer : '') + ' ' + (report.model ? report.model : '')">
          </td>
          <td v-if="report.estimate > 0" class="mdl-data-table__cell--non-numeric" v-text="report.estimate"></td>
          <td v-else class="mdl-data-table__cell--non-numeric newpricing" v-text="report.lineitemsestimate"></td>
          
          
          <td v-if="report.report_status == 3" class="mdl-data-table__cell--non-numeric smaller rejected" v-text="report.sent_at"><i class="material-icons mdl-list__item-icon">person</i></td>
          <td v-else-if="report.report_status == 2" class="mdl-data-table__cell--non-numeric smaller preliminary" v-text="report.sent_at"></td>
          <td v-else-if="report.report_status == 1" class="mdl-data-table__cell--non-numeric smaller confirmed" v-text="report.sent_at"></td>
          <td v-else-if="report.sent_at" class="mdl-data-table__cell--non-numeric smaller" v-text="report.sent_at"></td>
          <td v-else class="mdl-data-table__cell--non-numeric smaller" v-text=""></td>

          <td class="mdl-data-table__cell--non-numeric" v-text="getReportOwnerName(report)"></td>

          <td class="mdl-data-table__cell--non-numeric smaller" v-text="getReportInshuranceCompany(report)"></td>
          
        </tr>
        <tr v-if="!reports.length && !$root.ui.isLoading()">
          <td colspan="7" class="mdl-data-table__cell--non-numeric">No reports</td>
        </tr>
        <!--
        <tr class="yellow-chip">
          <td class="mdl-data-table__cell--non-numeric">23. juni 2017</td>
          <td class="mdl-data-table__cell--non-numeric">DP 54132</td>
          <td class="mdl-data-table__cell--non-numeric">VF Tech</td>
          <td class="mdl-data-table__cell--non-numeric">BMW i3</td>
        </tr>
        <tr class="red-chip">
          <td class="mdl-data-table__cell--non-numeric">23. juni 2017</td>
          <td class="mdl-data-table__cell--non-numeric">DP 54132</td>
          <td class="mdl-data-table__cell--non-numeric">VF Tech</td>
          <td class="mdl-data-table__cell--non-numeric">BMW i3</td>
        </tr>
        -->
        </tbody>
      </table>
      <div class="reportsPagination">
        <button :class="i==archive.filter.page ? 'selected' : '' " v-for="i in archive.pagesCount" v-if="isPageVisible(i)" @click="onPageChange(i)" class="mdl-button mdl-js-button mdl-button--icon mdl-button--colored">
          <i v-text="i"></i>
        </button>
      </div>
    </div>
  </main>
</template>

<script>

  import utils from '../mixins/utils.js'
  import clients from '../mixins/clients.js'
  import reports from '../mixins/reports.js'
  import DatePicker from 'vue2-datepicker'

  export default {
    components: { DatePicker },
    data () {
      return {
        //search: '',
      }
    },
    mixins: [utils, clients, reports],
    computed: {
        exportUrl(){
            let params = {}
            Object.keys(this.archive.filter).forEach((val, idx)=>{
                if(this.archive.filter[val])
                  params[val] = this.archive.filter[val]
            })
            params = new URLSearchParams(params).toString()
            return "/wp-admin/admin-ajax.php?action=mps_pt_export_reports&" + params
        }
        /*
      searched_reports(){
        var self = this
        if(self.search){
          return self.reports.filter(report => {
            var str = [report.contact_name, report.id_car, report.firma, report.model].join('|')
            return str.toLowerCase().indexOf(self.search.toLowerCase()) != -1
          })
        }else{
          return self.reports
        }
      }
      */
    },
    methods: {
      isFilterActive(){
          return this.archive.filter.search || this.archive.filter.startDate || this.archive.filter.endDate || this.archive.filter.id_client || this.archive.filter.id_client === 0
      },
      clearFilter(){
          this.$store.commit('clearFilterArchive')
          this.getReports()
      },
      getReports(){
        var self = this
        self.$root.ui.loading.push('getReports')
        return this.$store.dispatch('getReports', this.archive.filter).then(function(res){
          console.log(res);
          self.$root.ui.stopLoading('getReports')
        })
      },
      isPageVisible(i){
          return Math.abs(this.archive.filter.page - i) < 4 || i==1 || i==this.archive.pagesCount || Math.round(this.archive.pagesCount/2) == i;
      },
      onFilterChange(){
        this.archive.filter.page = 1;
        this.getReports()
      },
      onPageChange(page){
        this.archive.filter.page = page;
        this.getReports()
      },
      calculateTotalCost(sections){
        var cost = 0;
        sections.forEach(function(section) {
            section.items.forEach(function(thisitem) {
                thisitem.lineitems.forEach(function(lineitem) {
                    if (lineitem.cost > 0){
                        cost = cost + parseInt(lineitem.cost);
                    }
                });
            });
        });
        return cost
      },
      getReportClass(state){
        switch (parseInt(state)) {
          case 1:
              return 'green-chip'
          case 0:
              return 'yellow-chip'
          case -1:
              return 'red-chip'
          default:
              return ''
        }
      },
    },
    created: function(){
      var self = this;

      if (self.$root.isEuropcarDenmark() && self.$root.isAdministrator()) {
        console.log(this.$store);
        var archive = this.$store.getters.archive;

        archive.filter.onlyRegularReports = 0;
        archive.filter.onlyEuropcarReports = 0;
        archive.filter.onlyEuropcarReportsDansk = 1;

        this.$store.commit({type: 'archive', val: archive})

      }
      this.getReports()
    },
    /*
    mounted(){
      this.$parent.top_menu = this.$parent.topMenu()
      this.$parent.left_menu = this.$parent.leftMenu()
    }
    */
  }
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// Reports.vue?69f38b97